import {Box} from "@mui/system";
import styles from "../../organizationMainStyles";
import {Switch} from "@mui/material";
import {accessibilityMode} from "../organizationSettingsConstants";
import _ from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {buildPayAgentOnSkipPayload} from "../organizationSettingsUtils";
import {SnackBar} from "../../../../../common";
import {organizationSettingsActions} from "_actions";

export default function SkipPaymentToggleContainer({mode, organization, label}) {
    const disable = mode === accessibilityMode.READ_ONLY;
    const payAgentOnSkip = _.get(organization, 'payAgentOnSkip');
    const organizationSettings = useSelector(state => state.organizationSettings);
    const organizationAttribute = organizationSettings.organizationAttributeUpdate;
    const isPayAgentOnSkip = _.isEmpty(organizationAttribute) ? payAgentOnSkip : organizationAttribute.payAgentOnSkip;
    const organizationId = _.get(organization, 'id');
    const dispatch = useDispatch();

    const handleToggle = (event) => {
        const value = _.get(event, 'target.checked');
        handleUpdate(value);
    }

    const handleUpdate = (value) => {
        const payload = buildPayAgentOnSkipPayload(value);
        if(!organizationId || !payload) return SnackBar.showMessage('Invalid parameters');
        dispatch(organizationSettingsActions.updateOrganizationAttribute(organizationId, payload));
    }

    return(
        <Box>
            <Box component={'h2'} sx={styles.heading}>
                {label.PAY_AGENT_ON_SKIP}
            </Box>
            <Box sx={{mt: '8px'}}>
                <Switch disabled={disable} checked={isPayAgentOnSkip} onChange={handleToggle} sx={styles.switch} />
            </Box>
        </Box>
    )
}